import { render, staticRenderFns } from "./BaseInputCurrency.vue?vue&type=template&id=4f433d61&scoped=true"
import script from "./BaseInputCurrency.vue?vue&type=script&lang=js"
export * from "./BaseInputCurrency.vue?vue&type=script&lang=js"
import style0 from "./BaseInputCurrency.vue?vue&type=style&index=0&id=4f433d61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f433d61",
  null
  
)

export default component.exports